<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="normal"></app-breadcrumb>

<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Usuários do Município
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie todos os operadores do sistema. Utilize a busca e os filtros para encontrar e atualizar informações de forma eficiente.
        </p>
      </div>
    </div>

    <form #usuariosForm="ngForm" novalidate>
      <!-- Primeira linha de filtros -->
      <div class="form-row">
        <div class="col-6">
          <div class="form-group">
            <div class="controls">
              <label for="cidade">Cliente</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="cidade"
                  class="form-control"
                  [(ngModel)]="filters.cidade"
                  name="cidade"
                  placeholder="Digite o nome do cliente"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <div class="controls">
              <label for="nome">Nome</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  [(ngModel)]="filters.nome"
                  name="nome"
                  placeholder="Digite o nome do usuário"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <div class="controls">
              <label for="login">Usuário/Login</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="login"
                  class="form-control"
                  [(ngModel)]="filters.login"
                  name="login"
                  placeholder="Digite o login do usuário"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <!-- Segunda linha de filtros -->
      <div class="form-row">
        <div class="col-6">
          <div class="form-group">
            <div class="controls">
              <label for="periodoCadastro">Período de Cadastro</label>
              <div class="d-flex">
                <div class="input-group">
                  <input
                    type="text"
                    id="periodoCadastroInicio"
                    class="form-control"
                    mask="00/00/0000"
                    [(ngModel)]="filters.periodoCadastroInicio"
                    name="periodoCadastroInicio"
                    placeholder="dd/mm/yyyy"
                    aria-invalid="false"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                </div>
                <span class="mx-2 d-flex align-items-center">até</span>
                <div class="input-group">
                  <input
                    type="text"
                    id="periodoCadastroFim"
                    class="form-control"
                    mask="00/00/0000"
                    [(ngModel)]="filters.periodoCadastroFim"
                    name="periodoCadastroFim"
                    placeholder="dd/mm/yyyy"
                    aria-invalid="false"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <!-- Coluna vazia para manter o layout -->
        </div>
      </div>
    </form>

    <!-- Botões de filtro -->
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0"
          (click)="applyFilters()"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>

    <!-- Linha divisória -->
    <hr class="my-3">

    <!-- Botão adicionar usuário -->
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="openModal(cadastroUsuario, null, null)"
        >
          <i class="fa fa-plus mr-2"></i>Adicionar Usuário
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px">
  <table class="table table-striped text-center" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nomeCidade')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Município
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nomeCidade')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nomeCidade')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nomeCidade')"
                class="fa"
                [ngClass]="getSortIcon('nomeCidade')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('login')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Login
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('login')"
                class="fa"
                [ngClass]="getSortIcon('login')"
              ></i>
            </div>
          </div>
        </th>
        <th>Perfil de acesso</th>
        <th>
          <div class="d-flex align-items-center justify-content-center"></div>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="usuarios.length > 0">
      <tr *ngFor="let usuario of usuarios | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td class="pl-3 pr-3 align-middle">
          <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
            {{usuario.nomeCidade}}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">{{usuario.nome}}</td>
        <td class="text-center align-middle texto-linha-tabela">{{usuario.login}}</td>
        <td class="text-center align-middle">
          <select class="form-control form-control-sm" [ngModel]="usuario.origemAcesso || 'MUNICIPIO'"
            (ngModelChange)="atualizarOrigem(usuario, $event)">
            <option value="MUNICIPIO">Município · somente leitura no censo</option>
            <option value="BRPREV">BRPREV · acesso interno</option>
          </select>
        </td>
        <td class="d-flex justify-content-center align-items-center">
          <button type="button" class="btn btn-outline-danger mr-2 btn-square" (click)="deleteUsuario(usuario.id)">
            <i class="fa fa-trash"></i>
          </button>
          <button type="button" class="btn btn-outline-primary btn-retangle" (click)="openModal(atualizarSenha, usuario, '2')">
            Alterar Senha
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Paginação dos usuários -->
  <div class="form-row" *ngIf="usuarios.length > 0" style="padding: 0px 20px">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          Exibindo {{(page-1) * pageSize + 1}} a {{Math.min(page * pageSize, usuarios.length)}} de {{usuarios.length}} itens
        </div>
        <div class="d-flex justify-content-center">
          <ngb-pagination 
            style="margin-top: 10px"
            [(page)]="page"
            [pageSize]="pageSize"  
            [maxSize]="12"
            [collectionSize]="usuarios.length"
            class="pagination-square">
          </ngb-pagination>
        </div>
      </div>
    </div>

  <div class="text-center" *ngIf="usuarios.length == 0">
    <div class="card-content">
      <div class="card-body pt-0">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="media">
              <div class="media-body">
                <h5 class="mt-0">Nenhum usuário encontrado.</h5>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Modal para cadastro de usuário -->
<ng-template #cadastroUsuario let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Novo Usuário</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações Básicas</h6>
    
    <form #cadForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="estado" class="form-label">ESTADO</label>
            <ng-select [items]="estados" [appendTo]="'body'" name="estado" (change)="toggleEstado()" 
                       bindLabel="estado" bindValue="estado" placeholder="Selecione um Estado" 
                       id="estado" [(ngModel)]="novoUsuario.estado" [clearable]="false">
            </ng-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="cidade" class="form-label">MUNICÍPIO</label>
            <ng-select [items]="cidades" [appendTo]="'body'" [disabled]="!cidades || cidades.length==0" 
                       name="cidade" bindLabel="nome" bindValue="id" placeholder="Selecione um Município" 
                       id="cidade" [(ngModel)]="novoUsuario.cidade" [clearable]="false">
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="origemAcesso" class="form-label">PERFIL DE ACESSO</label>
            <select id="origemAcesso" class="form-control" name="origemAcesso" [(ngModel)]="novoUsuario.origemAcesso">
              <option value="MUNICIPIO">Município · somente leitura durante o censo</option>
              <option value="BRPREV">BRPREV · equipe interna</option>
            </select>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="nome" class="form-label">NOME</label>
            <input type="text" id="nome" class="form-control" name="nome" [(ngModel)]="novoUsuario.nome" 
                   placeholder="Digite o nome do usuário" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="login" class="form-label">USUÁRIO/LOGIN</label>
            <input type="text" id="login" class="form-control" name="login" [(ngModel)]="novoUsuario.login" 
                   placeholder="Digite o login do usuário" required>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="novaSenha" class="form-label">SENHA</label>
            <input type="password" id="novaSenha" class="form-control" name="novaSenha" [(ngModel)]="novoUsuario.senha" 
                   placeholder="Digite a senha" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="confirmaNovaSenha" class="form-label">CONFIRMAR SENHA</label>
            <input type="password" id="confirmaNovaSenha" class="form-control" name="confirmaNovaSenha" 
                   [(ngModel)]="novoUsuario.confirmaSenha" placeholder="Confirme a senha" required>
          </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')">
        Voltar
      </button>
      <button type="button" class="btn btn-primary"
              (click)="insertUsuario(modal)"
              [disabled]="!novoUsuario || !novoUsuario.nome || !novoUsuario.login || !novoUsuario.estado || !novoUsuario.cidade || !novoUsuario.senha || !novoUsuario.confirmaSenha || (novoUsuario.senha!=novoUsuario.confirmaSenha)">
        Cadastrar
      </button>
    </div>
  </div>
  
  <ngx-spinner></ngx-spinner>
</ng-template>

<!-- Modal para atualizar senha -->
<ng-template #atualizarSenha let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Alterar Senha</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações de Segurança</h6>
    
    <form #exForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="novaSenhaAlt" class="form-label">NOVA SENHA</label>
            <input type="password" id="novaSenhaAlt" class="form-control" name="novaSenhaAlt" 
                   [(ngModel)]="atualizacaoSenha.novaSenha" placeholder="Digite a nova senha" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="confirmaNovaSenhaAlt" class="form-label">CONFIRMAR NOVA SENHA</label>
            <input type="password" id="confirmaNovaSenhaAlt" class="form-control" name="confirmaNovaSenhaAlt" 
                   [(ngModel)]="atualizacaoSenha.confirmaNovaSenha" placeholder="Confirme a nova senha" required>
          </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn" (click)="modal.dismiss('Cancel')">
        Voltar
      </button>
      <button type="button" class="btn btn-primary"
              (click)="updateSenha(modal)"
              [disabled]="!atualizacaoSenha || !atualizacaoSenha.novaSenha || !atualizacaoSenha.confirmaNovaSenha || (atualizacaoSenha.novaSenha!=atualizacaoSenha.confirmaNovaSenha)">
        Atualizar
      </button>
    </div>
  </div>
  
  <ngx-spinner></ngx-spinner>
</ng-template>

<ngx-spinner></ngx-spinner>
